import styles from './description.module.scss';
const UploadImageDescription = () => {
  return (
    <>
      <div className={styles['description']}>
        <div>
          <small className="text-gray-6">
            با افزودن عکس از محصول یا مزرعه خود بازدید آگهی را افزایش دهید.
          </small>
        </div>
        <ul className="p-0 px-3 pt-2">
          <li>
            <small className="text-gray-6">
              تصویر باید فقط کالایی که قصد فروش آن را دارید نمایش دهد و بدون هیچ
              لوگو، نوشته و یا واترمارکی باشد.
            </small>
          </li>
          <li>
            <small className="text-gray-6">
              تصویر شما باید مستطیلی باشد یا ابعاد ۳ در ۲ داشته باشد.
            </small>
          </li>
          <li>
            <small className="text-gray-6">فرمت تصاویر بایستی JPG باشد.</small>
          </li>
        </ul>
      </div>
    </>
  );
};

export default UploadImageDescription;
